
// import { useNavigate } from 'react-router-dom';
// import React, { useState, useEffect } from 'react';
// import '../styles/Attendance.css';

// const MedicalReports = () => {
//     const [reports, setReports] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [viewMode, setViewMode] = useState('pending'); // 'pending' or 'history'
//     const [selectedPhoto, setSelectedPhoto] = useState(null);
//     const [selectedLeaveId, setSelectedLeaveId] = useState(null);

//     useEffect(() => {
//         fetchReports();
//     }, [viewMode]); // Refetch when switching tabs

//     const fetchReports = async () => {
//         setLoading(true);
//         try {
//             // Passing viewMode to API to filter Status 0 vs Status 1,2
//             const response = await fetch(`/gt-api/get_all_medical_reports.php?mode=${viewMode}`);
//             const data = await response.json();
//             if (data.success) {
//                 setReports(data.reports);
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//         } finally {
//             setLoading(false);
//         }
//     };


  

//     const handleViewDocument = (fileName, leaveId) => {
//         const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
//         setSelectedLeaveId(leaveId);
//         setSelectedPhoto(fileUrl);
//     };

//     const handleVerifyAction = async (actionType) => {
//         if (!selectedLeaveId) return;
//         const formData = new URLSearchParams();
//         formData.append('leave_id', selectedLeaveId);
//         formData.append('action', actionType);

//         try {
//             const response = await fetch("/gt-api/update_medical_status.php", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/x-www-form-urlencoded" },
//                 body: formData.toString()
//             });
//             const result = await response.json();
//             if (result.success) {
//                 setSelectedPhoto(null);
//                 fetchReports();
//                 alert("Status Updated Successfully");
//             }
//         } catch (error) {
//             console.error("Update Error:", error);
//         }
//     };

//     return (
//         <div className="attendance-module animate-fade">
            
//             {/* FULL SCREEN IMAGE OVERLAY */}
//             {selectedPhoto && (
//                 <div className="cyber-full-overlay" onClick={() => setSelectedPhoto(null)} style={{ position: 'fixed', top: 0, left: 0, width: '80vw', height: '90vh', background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20px', overflowY: 'auto' }}>
                    
//                     {/* Only show buttons if we are in Pending mode */}
//                     {viewMode === 'pending' && (
//                         <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', position: 'sticky', top: 0 }}>
//                             <button className="btn-yes" onClick={() => handleVerifyAction('verify')}>✓ APPROVE</button>
//                             <button className="btn-no" onClick={() => handleVerifyAction('reject')}>✕ REJECT</button>
//                         </div>
//                     )}

//                     <img src={selectedPhoto} alt="Log" style={{ maxWidth: '50%', height: '450px', border: '2px solid #00f2ff', borderRadius: '8px' }} onClick={(e) => e.stopPropagation()} />
//                     <p style={{color: '#fff', margin: '20px 0'}}>Click outside to close</p>
//                 </div>
//             )}

//             <div className="panel glass">
//                 <div className="panel-header">
//                     <div style={{ display: 'flex', gap: '20px' }}>
//                         <h3 
//                             className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('pending')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'pending' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             PENDING_DOCS
//                         </h3>
//                         <h3 
//                             className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`} 
//                             onClick={() => setViewMode('history')}
//                             style={{ cursor: 'pointer', borderBottom: viewMode === 'history' ? '2px solid #00f2ff' : 'none' }}
//                         >
//                             APPLICATION_LOG (HISTORY)
//                         </h3>
//                     </div>
//                     <span className="deduction-badge">{reports.length} FILES</span>
//                 </div>

//                 <div className="table-scroll">
//                     <table className="history-table">
//                         <thead>
//                             <tr>
//                                 <th>EMP_ID</th>
//                                 <th>EMPLOYEE_NAME</th>
//                                 <th>LEAVE_PERIOD</th>
//                                 <th>STATUS</th>
//                                 <th>ACTION</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {reports.map((report) => (
//                                 <tr key={report.id}>
//                                     {/* Changed from report.empid to report.EmpId per your request */}
//                                     <td>{report.EmpId}</td>
//                                     {/* Changed from report.EmailId to report.EmployeeName */}
//                                     <td>{report.EmployeeName}</td>
//                                     <td>{report.fromdate} → {report.todate}</td>
//                                     <td>
//                                         {viewMode === 'history' ? (
//                                             <span className={`status-pill ${report.medical_doc_status === '1' ? 'approved' : 'rejected'}`}>
//                                                 {report.medical_doc_status === '1' ? 'VERIFIED' : 'REJECTED'}
//                                             </span>
//                                         ) : (
//                                             <span className="status-pill pending">WAITING</span>
//                                         )}
//                                     </td>
//                                     <td>
//                                         <button className="action-upload" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
//                                             VIEW_LOG
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MedicalReports;


























import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import '../styles/Attendance.css';

const MedicalReports = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const prevTheme = document.documentElement.getAttribute('data-theme');
        document.documentElement.setAttribute('data-theme', 'light');

        const prevBodyBg = document.body.style.backgroundColor;
        const prevBodyColor = document.body.style.color;
        document.body.style.backgroundColor = '#f8fafc';
        document.body.style.color = '#1e293b';

        return () => {
            if (prevTheme) {
                document.documentElement.setAttribute('data-theme', prevTheme);
            } else {
                document.documentElement.removeAttribute('data-theme');
            }
            document.body.style.backgroundColor = prevBodyBg;
            document.body.style.color = prevBodyColor;
        };
    }, []);

    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [viewMode, setViewMode] = useState('pending'); // 'pending' or 'history'
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [selectedLeaveId, setSelectedLeaveId] = useState(null);

    useEffect(() => {
        fetchReports();
    }, [viewMode]); // Refetch when switching tabs

    const fetchReports = async () => {
        setLoading(true);
        try {
            // Passing viewMode to API to filter Status 0 vs Status 1,2
            const response = await fetch(`/gt-api/get_all_medical_reports.php?mode=${viewMode}`);
            const data = await response.json();
            if (data.success) {
                setReports(data.reports);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setLoading(false);
        }
    };




    const handleViewDocument = (fileName, leaveId) => {
        const fileUrl = `/gt-api/uploads/medical_docs/${fileName}`;
        setSelectedLeaveId(leaveId);
        setSelectedPhoto(fileUrl);
    };

    const handleVerifyAction = async (actionType) => {
        if (!selectedLeaveId) return;
        const formData = new URLSearchParams();
        formData.append('leave_id', selectedLeaveId);
        formData.append('action', actionType);

        try {
            const response = await fetch("/gt-api/update_medical_status.php", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString()
            });
            const result = await response.json();
            if (result.success) {
                setSelectedPhoto(null);
                fetchReports();
                alert("Status Updated Successfully");
            }
        } catch (error) {
            console.error("Update Error:", error);
        }
    };

    return (
        <div className="attendance-module light-theme animate-fade">

            <div style={{ marginBottom: '20px' }}>
                <button
                    className="wfh-top-btn"
                    onClick={() => navigate(-1)}
                >
                    ⬅ Back to Leave Management
                </button>
            </div>

            {/* FULL SCREEN IMAGE OVERLAY */}
            {selectedPhoto && (
                <div className="cyber-full-overlay" onClick={() => setSelectedPhoto(null)} style={{ position: 'fixed', top: 0, left: 0, width: '80vw', height: '90vh', background: 'rgba(0,0,0,0.95)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20px', overflowY: 'auto' }}>

                    {/* Only show buttons if we are in Pending mode */}
                    {viewMode === 'pending' && (
                        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', position: 'sticky', top: 0 }}>
                            <button className="btn-yes" onClick={() => handleVerifyAction('verify')}>✓ APPROVE</button>
                            <button className="btn-no" onClick={() => handleVerifyAction('reject')}>✕ REJECT</button>
                        </div>
                    )}

                    <img src={selectedPhoto} alt="Log" style={{ maxWidth: '50%', height: '450px', border: '2px solid #00f2ff', borderRadius: '8px' }} onClick={(e) => e.stopPropagation()} />
                    <p style={{ color: '#fff', margin: '20px 0' }}>Click outside to close</p>
                </div>
            )}

            <div className="panel glass">
                <div className="panel-header">
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <h3
                            className={`panel-title ${viewMode === 'pending' ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setViewMode('pending')}
                            style={{ cursor: 'pointer', borderBottom: viewMode === 'pending' ? '2px solid #3b82f6' : 'none' }}
                        >
                            PENDING_DOCS
                        </h3>
                        <h3
                            className={`panel-title ${viewMode === 'history' ? 'active-tab' : 'inactive-tab'}`}
                            onClick={() => setViewMode('history')}
                            style={{ cursor: 'pointer', borderBottom: viewMode === 'history' ? '2px solid #3b82f6' : 'none' }}
                        >
                            APPLICATION_LOG (HISTORY)
                        </h3>
                    </div>
                    <span className="deduction-badge">{reports.length} FILES</span>
                </div>

                <div className="table-scroll">
                    <table className="history-table">
                        <thead>
                            <tr>
                                <th>EMP_ID</th>
                                <th>EMPLOYEE_NAME</th>
                                <th>LEAVE_PERIOD</th>
                                <th>STATUS</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reports.map((report) => (
                                <tr key={report.id}>
                                    {/* Changed from report.empid to report.EmpId per your request */}
                                    <td>{report.EmpId}</td>
                                    {/* Changed from report.EmailId to report.EmployeeName */}
                                    <td>{report.EmployeeName}</td>
                                    <td>{report.fromdate} → {report.todate}</td>
                                    <td>
                                        {viewMode === 'history' ? (
                                            <span className={`status-pill ${report.medical_doc_status === '1' ? 'approved' : 'rejected'}`}>
                                                {report.medical_doc_status === '1' ? 'VERIFIED' : 'REJECTED'}
                                            </span>
                                        ) : (
                                            <span className="status-pill pending">WAITING</span>
                                        )}
                                    </td>
                                    <td>
                                        <button className="action-upload" onClick={() => handleViewDocument(report.medical_doc, report.id)}>
                                            VIEW_LOG
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MedicalReports;







